import React, {useEffect} from "react";
import "./Products.scss";
import p1 from "./imgs/4.jpg";
import p2 from "./imgs/2.jpg";
import p3 from "./imgs/3.jpg";
import p4 from "./imgs/1.jpg";
import p5 from "./imgs/5.jpg";
import p1en from "./imgs/4-en.jpg";
import p2en from "./imgs/2-en.jpg";
import p3en from "./imgs/3-en.jpg";
import p4en from "./imgs/1-en.jpg";
import p5en from "./imgs/5.jpg";

import {withRouter} from 'react-router-dom';
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";

function Products({history}) {
    const lang = LOCALES_HELPER.getLan();

    useEffect(() => {
        new window.Swiper('.swiper-container.product-detail-banner', {
            pagination: '.swiper-pagination',
            nextButton: '.swiper-button-next.product-banner',
            prevButton: '.swiper-button-prev.product-banner',
            paginationClickable: true,
            slidesPerView: 3,
            loopedSlides: 4,
            spaceBetween: 80,
            centeredSlides: true,
            loop: true,
            onClick: function (s) {
                if (s.clickedSlide) {
                    let path = s.clickedSlide.getAttribute("date-href");
                    history.push(`/product/${path}`);
                }
            }
        });
    }, []);

    return <>
        <div className="swiper-container product-detail-banner">
            <div className="swiper-wrapper">
                <div className="swiper-slide" date-href='rSmartPro'>
                    <div className="product-item">
                        <article>
                            <figure title="R-Smart Pro">
                                <img src={lang === DEFAULT_LOCALE ? p5 : p5en} alt="image" className="responsive"/>
                                <figcaption className="text-center light-color">
                                    <h3 className="text-ellipse"
                                        style={{marginBottom: DEFAULT_LOCALE === lang ? "auto" : 0}}
                                    >R-Smart Pro</h3>
                                    <small>{DEFAULT_LOCALE === lang ? "根管治疗仪" : ""}</small>
                                </figcaption>
                            </figure>
                        </article>
                    </div>
                </div>
                <div className="swiper-slide" date-href='rSmartPlus'>
                    <div className="product-item">
                        <article>
                            <figure title="R-Smart Plus">
                                <img src={lang === DEFAULT_LOCALE ? p4 : p4en} alt="image" className="responsive"/>
                                <figcaption className="text-center light-color">
                                    <h3 className="text-ellipse"
                                        style={{marginBottom: DEFAULT_LOCALE === lang ? "auto" : 0}}
                                    >R-Smart Plus</h3>
                                    <small>{DEFAULT_LOCALE === lang ? "根管预备机" : ""}</small>
                                </figcaption>
                            </figure>
                        </article>
                    </div>
                </div>
                <div className="swiper-slide" date-href='rSmartMini'>
                    <div className="product-item">
                        <article>
                            <figure title="R-Smart Mini">
                                <img src={lang === DEFAULT_LOCALE ? p1 : p1en} alt="image" className="responsive"/>
                                <figcaption className="text-center light-color">
                                    <h3 className="text-ellipse"
                                        style={{marginBottom: DEFAULT_LOCALE === lang ? "auto" : 0}}
                                    >R-Smart Mini</h3>
                                    <small>{DEFAULT_LOCALE === lang ? "无线根管预备机" : ""}</small>
                                </figcaption>
                            </figure>
                        </article>
                    </div>
                </div>
                <div className="swiper-slide" date-href='rpex6'>
                    <div className="product-item">
                        <article>
                            <figure title="RPEX 6">
                                <img src={lang === DEFAULT_LOCALE ? p2 : p2en} alt="image" className="responsive"/>
                                <figcaption className="text-center light-color">
                                    <h3 className="text-ellipse"
                                        style={{marginBottom: DEFAULT_LOCALE === lang ? "auto" : 0}}
                                    >RPEX 6</h3>
                                    <small>{DEFAULT_LOCALE === lang ? "根管长度测量仪" : ""}</small>
                                </figcaption>
                            </figure>
                        </article>
                    </div>
                </div>
                <div className="swiper-slide" date-href='RLED6'>
                    <div className="product-item">
                        <article>
                            <figure title="R-Smart Plus">
                                <img src={lang === DEFAULT_LOCALE ? p3 : p3en} alt="image" className="responsive"/>
                                <figcaption className="text-center light-color">
                                    <h3 className="text-ellipse"
                                        style={{marginBottom: DEFAULT_LOCALE === lang ? "auto" : 0}}
                                    >RLED 6</h3>
                                    <small>{DEFAULT_LOCALE === lang ? "光固化机" : ""}</small>
                                </figcaption>
                            </figure>
                        </article>
                    </div>
                </div>

            </div>
            <div className="swiper-pagination"></div>
            <div className="swiper-button-next product-banner"></div>
            <div className="swiper-button-prev product-banner"></div>
        </div>
    </>
}

export default withRouter(Products);
